/* the aim of this service is to allow for the storage and modification of the
current language across the site. */

import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { TranslateService } from '@ngx-translate/core';

const DEFAULT_LANG = "en";
const STORAGE_LANG_KEY = "user_lang";

@Injectable({
    providedIn: "root"
})
export class LanguageService {

    constructor(
        private localStorageService: LocalStorageService,
        private translateService: TranslateService
    ){
        this.translateService.setDefaultLang(DEFAULT_LANG);
        this.setLanguage(this.getLanguage());
    }

    public getLanguage(): string {
        const storedLanguage = this.localStorageService.getItem<string>(STORAGE_LANG_KEY);
        return storedLanguage ? storedLanguage : DEFAULT_LANG;
    }

    public setLanguage(languageCode: string) {
        this.localStorageService.setItem(STORAGE_LANG_KEY, languageCode);
        this.translateService.use(languageCode);
    }

    public async init(): Promise<void> {
        const lang = this.getLanguage();
        await this.translateService.use(lang).toPromise();
    }
}